import { motion } from "framer-motion";
import { Award, Shield, TrendingUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const highlights = [
  {
    icon: Award,
    title: "Legenda sítě RE/MAX",
    description: "Jako teprve pátý makléř v ČR jsem získal prestižní ocenění Lifetime Achievement za celoživotní přínos a výsledky.",
  },
  {
    icon: Shield,
    title: "Stabilita a autorita",
    description: "Již 30 let působím na trhu a od roku 2014 jsem pilířem jedné z nejúspěšnějších kanceláří – RE/MAX Alfa.",
  },
  {
    icon: TrendingUp,
    title: "Důkaz místo slibů",
    description: "Patřím mezi TOP 10 nejlepších makléřů sítě v České republice (2021–2025).",
  },
];

const ease = [0.22, 1, 0.36, 1] as const;

const AboutSection = () => {
  return (
    <section id="o-mne" className="section-padding bg-background">
      <div className="container-luxury">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease }}
            className="text-center mb-16"
          >
            <span className="badge-remax mb-6">Moje vize · 30 let zkušeností</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight mb-6">
              Reality jsou pro mě{" "}
              <span className="text-primary">maraton, ne sprint.</span>
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Od roku 1996 pomáhám lidem bezpečně prodávat jejich domovy. Za tu dobu se trh změnil k nepoznání, ale moje zásada zůstává stejná: Poctivé řemeslo podložené daty a moderními technologiemi.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {highlights.map((h, i) => (
              <motion.div
                key={h.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.15 * i, ease }}
                whileHover={{ y: -8, transition: { duration: 0.3, ease: "easeOut" } }}
                className="glass-card-hover p-8 text-center"
              >
                <motion.div
                  whileHover={{ scale: 1.15, rotate: 8 }}
                  transition={{ type: "spring", stiffness: 400, damping: 15 }}
                  className="icon-glossy inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-5"
                  style={{
                    background: 'linear-gradient(135deg, #002349, hsl(215 65% 42%))',
                    boxShadow: '0 8px 25px -6px hsl(215 65% 42% / 0.35), inset 0 1px 0 rgba(255,255,255,0.12)',
                  }}
                >
                  <h.icon className="h-6 w-6 text-white/90" strokeWidth={1.5} />
                </motion.div>
                <h3 className="text-lg font-heading font-bold text-foreground mb-3">
                  {h.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed text-sm">
                  {h.description}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.5, ease }}
            className="text-center"
          >
            <Button
              size="lg"
              className="btn-glass-hover group text-base px-8 py-6 rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => window.location.href = "/o-mne"}
            >
              Poznejte můj příběh a vizi
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
